module.exports = __webpack_public_path__ + "img/logo_daishin@3x.a32d89a4.png";